import { render } from "./VoteResults.vue?vue&type=template&id=2622168c&scoped=true"
import script from "./VoteResults.vue?vue&type=script&lang=js"
export * from "./VoteResults.vue?vue&type=script&lang=js"

import "./VoteResults.vue?vue&type=style&index=0&id=2622168c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2622168c"]])

export default __exports__